'use strict';

/**
 * Returns the first visible delivery input element (excluding hidden ones).
 * @returns {JQuery} The active delivery input field.
 */
function getActiveDeliveryInput() {
    return $('.delivery-check-input').not('.d-none').first();
}

/**
 * Toggles between pincode and city input fields based on selected option data.
 * Updates visibility, required attribute, and placeholder dynamically.
 * @param {JQuery} $selectedOption - The selected option element with data attributes.
 */
function toggleInputField($selectedOption) {
    var hasPostal = $selectedOption.data('has-postal');
    var showCity = hasPostal === false || hasPostal === 'false';
    var $pincodeInput = $('.delivery-check-pincode');
    var $cityInput = $('.delivery-check-city');
    var cityDisplayName = $selectedOption.data('city-display-name') || 'City';

    if (showCity) {
        $pincodeInput.addClass('d-none').removeAttr('required').val('');
        $cityInput.removeClass('d-none').attr('required', 'required');
        $cityInput.attr('placeholder', 'Enter ' + cityDisplayName);
    } else {
        $cityInput.addClass('d-none').removeAttr('required').val('');
        $pincodeInput.removeClass('d-none').attr('required', 'required');
    }
}

/**
 * Validates whether a pincode is invalid for a given country.
 *
 * @param {string} pincode - The pincode to validate.
 * @param {string} countryCode - The ISO country code (e.g., 'IN').
 * @param {string} countryRegex - The regex string to validate the pincode format for the country.
 * @returns {boolean} Returns `true` if the pincode is invalid, otherwise `false`.
 */
function isInvalidPincode(pincode, countryCode, countryRegex) {
    if (!pincode) return true;
    var regex = new RegExp(countryRegex);
    if (countryCode === 'IN') {
        // India: must be exactly 6 digits, not all same
        var fancyPinRegex = /^(\d)\1{5}$/;
        return !regex.test(pincode) || fancyPinRegex.test(pincode);
    }
    return !regex.test(pincode);
}

/**
 * Checks if the delivery pincode input is valid and triggers the delivery check action.
 * - Gets the value from the pincode input field.
 * - Checks if the input has a value and meets the minimum length.
 * - If valid, simulates a click on the delivery check button.
 */
function handleDeliveryCheck() {
    var inputField = getActiveDeliveryInput();
    var prefilledValue = inputField.val();
    var minLength = parseInt(inputField.attr('minlength'), 10) || 0;
    if (prefilledValue && (inputField.hasClass('delivery-check-city') || prefilledValue.length >= minLength)) {
        $('.delivery-check-cta').trigger('click');
    }
}

/**
 * Updates the placeholder text of the postal code input field
 * based on the selected country.
 *
 * If the country is India ('IND'), it applies the domestic placeholder.
 * Otherwise, it applies the international placeholder.
 *
 * @param {string} selectedCountry - The ISO country code.
 */
function updatePostalCodePlaceholder(selectedCountry) {
    if (selectedCountry === 'IND') {
        $('#postalCode').attr('placeholder', $('.delivery-check-input').data('placeholder-domestic')); // Domestic
    } else {
        $('#postalCode').attr('placeholder', $('.delivery-check-input').data('placeholder-international')); // International
    }
}

/**
 * Updates the delivery country selection UI and hidden field.
 * Retrieves the selected country text and value from the clicked element,
 * updates the visible selected value, and triggers change on the hidden selector.
 *
 * @function setDeliveryCountry
 * @param {jQuery} $element - The clicked dropdown option (jQuery object)
 * containing country text and data-id attribute.
 *
 * @returns {void}
 */
function setDeliveryCountry($element) {
    var selectedText = $element.text();
    var selectedValue = $element.data('id');

    $element.closest('.delivery-check-drop-down')
        .find('.selected-value').text(selectedText); // Update selected country

    $('#deliveryCountrySelector') // Updates hidden select
        .val(selectedValue)
        .trigger('change'); // trigger existing logic
}

$(document).ready(function () {
    $('.delivery-check-cta').on('click', function (e) {
        e.preventDefault();
        var deliveryValue;
        var $selectedOption = $('#deliveryCountrySelector option:selected');
        var $activeInput = getActiveDeliveryInput();
        var inputEl = $activeInput[0];
        var countryCode = $selectedOption.data('id');
        var countryRegex = $selectedOption.data('regex');
        var isCityInput = $activeInput.hasClass('delivery-check-city');
        if (!inputEl) return;
        var isValueMissing = inputEl.validity.valueMissing;
        var isRangeError = !isCityInput && (inputEl.validity.tooLong || inputEl.validity.tooShort);
        var $btn = $(this);
        var errorMsg = '';

        var nonServiceDescMsg = $('.non-serviceable-label').data('desc-msg');

        if (isRangeError) {
            errorMsg = $btn.data('pattern-mismatch');
        } else if (isValueMissing) {
            errorMsg = $btn.data('missing-error');
        }

        var invalidPincodeLable = $('.delivery-check-input').data('invalid-message-domestic');

        var message = `<span class="invalid-feedback invalid-pincode d-block m-0">${invalidPincodeLable}</span>`;

        if (errorMsg) {
            countryCode = $activeInput.data('isocode');
            var inputType = $activeInput.data('checkfield');
            var suffix = '';
            if (inputType === 'pincode') {
                suffix = countryCode === 'IN' ? ' pincode' : ' zipcode';
            } else {
                suffix = ' city';
            }
            var fullMsg = errorMsg + suffix;
            var fieldErrorMessage = `<span class="invalid-feedback invalid-pincode d-block m-0">${fullMsg}</span>`;

            var attrName = '';
            deliveryValue = isCityInput ? $activeInput.val().trim() : $activeInput.val().replace(/\s+/g, '');
            if (deliveryValue.length <= 5) {
                $activeInput.addClass('is-invalid');
                $('.delivery-status').html(fieldErrorMessage);
            } else {
                $activeInput.removeClass('is-invalid');
            }
            $activeInput.attr(attrName, fullMsg).addClass('is-invalid');
            $('.delivery-status').empty();
            $('.delivery-status').html(fieldErrorMessage);
        } else {
            if (!$('.delivery-check-form').attr('action')) return;
            deliveryValue = isCityInput ? $activeInput.val().trim() : $activeInput.val().replace(/\s+/g, '');

            if (!isCityInput && isInvalidPincode(deliveryValue, countryCode, countryRegex)) {
                $('.delivery-status').html(message);
                return;
            }

            if (isCityInput) {
                if (deliveryValue.length <= 2) {
                    $('.delivery-status').html(message);
                    return;
                }
                $activeInput.val(deliveryValue);
            }

            var url = $('.delivery-check-form').attr('action') + '?' + $('.delivery-check-form').serialize();
            $.ajax({
                url: url,
                type: 'GET',
                data: {
                    countryCode: countryCode
                },
                success: function (data) {
                    message = '';
                    var serviceableMessage = '';
                    if (data.success) {
                        if ($('.cart-page').length) {
                            $('.non-serviceable-label').empty().addClass('d-none').removeClass('d-flex');
                        }
                        message = `
                            <span class="normal-message expected-label">${data.message}</span>
                            <span class="success-message expected-date">${data.deliveryDate}</span>`;
                    } else {
                        if ($('.cart-page').length && data.isDeliveryAvailable === false) {
                            serviceableMessage = `
                            <span class="success-message expected-date">${data.serviceableMessage}</span>
                            <span class="desc">${nonServiceDescMsg}</span>`;
                        }
                        message = `<span class="invalid-feedback not-serviceable d-inline">${data.message}</span>`;
                    }

                    $('.delivery-check').find('.delivery-status').empty().append(message);
                    if (serviceableMessage) {
                        $('.cart-page').find('.non-serviceable-label').addClass('d-flex').empty()
                            .append(serviceableMessage);
                    }

                    // Non servicable selective checkout
                    $('body').trigger('selectiveCheckout:nonServiceable', data.isDeliveryAvailable);
                },
                error: function () {
                }
            });
        }
    });

    $('#deliveryCountrySelector option').each(function () {
        if ($(this).is(':selected')) {
            $(this).attr('selected', 'selected');
        } else {
            $(this).removeAttr('selected');
        }
    });

    $('#deliveryCountrySelector').on('change', function () {
        $('#deliveryCountrySelector option').removeAttr('selected');
        $(this).find('option:selected').attr('selected', 'selected');
        var selectedCountry = $('#deliveryCountrySelector').val();
        var $selectedOption = $(this).find('option:selected');
        toggleInputField($selectedOption);
        updatePostalCodePlaceholder(selectedCountry);
        $('.delivery-check-input').val('');
        $('.delivery-status').html('');
        if (selectedCountry !== 'IND') {
            $('.available-location').addClass('d-none');
        } else {
            $('.available-location').removeClass('d-none');
        }
    });

    $('.delivery-check-pincode').on('input', function () {
        $('.delivery-status').html('');
        var $input = $(this);
        var selectedOption = $('#deliveryCountrySelector option:selected');
        var countryRegex = selectedOption.data('regex');
        var minLength = selectedOption.data('min-length');
        var maxLength = selectedOption.data('max-length');

        $input.attr('minlength', minLength).attr('maxlength', maxLength);

        if (!countryRegex) return;

        $input.attr('minlength', minLength).attr('maxlength', maxLength);

        var regexRegexPattern = countryRegex.replace(/\{(\d+)\}/, '{0,$1}');
        var relRegex = new RegExp(regexRegexPattern);

        var inputVal = $input.val();

        if (!relRegex.test(inputVal)) {
            $input.val(inputVal.slice(0, -1));
        }
    });

    $('.delivery-check-city').on('input', function () {
        $('.delivery-status').html('');
    });

    // TO update min-length, max-length, placeholder based on preselected country
    var $selectedCountry = $('.custom-option-value.delivery-check-country.selected');
    if ($selectedCountry.length) {
        // Get the data attributes
        var minLen = $selectedCountry.data('min-length');
        var maxLen = $selectedCountry.data('max-length');
        // Update the postal code input attributes
        var $input = $('#postalCode');
        $input.attr('minlength', minLen);
        $input.attr('maxlength', maxLen);
        toggleInputField($('#deliveryCountrySelector option:selected'));
        updatePostalCodePlaceholder($selectedCountry);
    }

    handleDeliveryCheck();

    $('.delivery-check-country').on('click', function () { // Handle custom option selection
        setDeliveryCountry($(this));
    });

    var selectedText = $('#deliveryCountrySelector option:selected').text();
    $('.delivery-check-drop-down .selected-value').text(selectedText);
});

$('#check-availability-btn').on('click', function () {
    $('#availability-modal').modal('show');
});

$(window).on('resize load', function () {
    var $page = $('.page');
    var action = $page.data('action'); // gets the value of data-action
    var $modal = $('#availability-modal');

    // Run this logic only if data-action="Product-Show"
    if (action === 'Product-Show') {
        if ($(window).width() >= 1024) {
            if ($modal.hasClass('show')) {
                $modal.modal('hide');
            }
            $modal.removeClass('modal');
            $modal.addClass('d-block');
        } else {
            $modal.addClass('modal');
            $modal.removeClass('d-block');

            $modal.on('hidden.bs.modal', function () {
                if ($('.delivery-status').find('.invalid-pincode').length > 0) {
                    $('.delivery-status').empty();
                }
            });
        }
    } else if (action === 'Cart-Show') {
        $modal.removeClass('modal').addClass('d-block');
    }
});

/**
 * Moves the non-serviceable message to different locations
 * depending on the current viewport width.
 *
 * For mobile (<1023px), it moves the message after `.cart-item-details`.
 * For desktop (>=1023px), it appends it inside `.item-info`.
 *
 * @function moveNonServiceableMsg
 * @returns {void}
 */
function moveNonServiceableMsg() {
    $('.product-info').each(function () {
        var $card = $(this);
        var $nonServiceableLabel = $card.find('.non-serviceable-label');
        var $target;

        if ($(window).width() < 1023) {
            $target = $card.find('.cart-item-details');
        } else {
            $target = $card.find('.item-info');
        }
        $nonServiceableLabel.appendTo($target);
    });
}

moveNonServiceableMsg();

$(window).resize(function () {
    moveNonServiceableMsg();
});

window.setDeliveryCountry = setDeliveryCountry;
